module.exports = __webpack_public_path__ + "static/img/skin-report-3.1b020a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skinReport/skin-report-3.png
// module id = Kfvf
// module chunks = 1